// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  cursor: text;
}
.v-autocomplete input {
  align-self: center;
}
.v-autocomplete--is-selecting-index input {
  opacity: 0;
}
.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 24px;
}
.v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {
  pointer-events: inherit;
}
.v-autocomplete__content.v-menu__content {
  border-radius: 0;
}
.v-autocomplete__content.v-menu__content .v-card {
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_autocompletes.styl"],"names":[],"mappings":"AACE;EACE,YAAQ;AAAZ;AAEE;EACE,kBAAY;AAAhB;AAGI;EACE,UAAS;AADf;AAMI;EACE,gBAAY;AAJlB;AAOI;EACE,uBAAgB;AALtB;AAOE;EACE,gBAAe;AALnB;AAOI;EACE,gBAAe;AALrB","sourcesContent":[".v-autocomplete\n  &.v-input > .v-input__control > .v-input__slot\n    cursor: text\n\n  input\n    align-self: center\n\n  &--is-selecting-index\n    input\n      opacity: 0\n\n  // When a single select, does not have\n  // selections padding\n  &.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line)\n    .v-select__slot > input\n      margin-top: 24px\n\n  &:not(.v-input--is-disabled).v-select.v-text-field\n    input\n      pointer-events: inherit\n\n  &__content.v-menu__content\n    border-radius: 0\n\n    .v-card\n      border-radius: 0\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
